import type { RoleDefinition, IntelligenceAnalysis } from '../types/api';

const FUNCTION_URL = '/api/analyze-match';

export async function requestAnalysis(
  role: RoleDefinition,
  candidateData: Record<string, unknown>,
  candidateId?: string,
): Promise<IntelligenceAnalysis> {
  const res = await fetch(FUNCTION_URL, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ role, candidateData, candidateId }),
  });

  if (!res.ok) {
    // If rate limited or error, try to parse fallback from response
    const errorBody = await res.json().catch(() => null);
    if (errorBody?.fallback) {
      return errorBody.fallback as IntelligenceAnalysis;
    }
    throw new Error(`Analysis failed: ${res.status}`);
  }

  const json = await res.json();
  return json as IntelligenceAnalysis;
}
